import React, { useEffect, useState } from 'react'
import { auth as firebaseAuth, signInWithCustomToken } from '~/providers/firebase'
import DiagnosticsResult from '../DiagnosticsResult'
import { Status } from '../types'

export default function FirebaseAuthenticationChecker(): React.JSX.Element {
  const [status, setStatus] = useState<Status>('inprogress')
  const [error, setError] = useState<Error>()

  useEffect(() => {
    let cancel = false

    async function auth() {
      try {
        await signInWithCustomToken(firebaseAuth, 'ping.ping.ping')

        // Impossible
        if (!cancel) {
          setStatus('failed')
          setError(undefined)
        }
      } catch (error) {
        if (!cancel) {
          if (error.code === 'auth/invalid-custom-token') {
            setStatus('success')
            setError(undefined)
          } else {
            setStatus('failed')
            setError(error)
          }
        }
      }
    }

    auth()

    return () => {
      cancel = true
    }
  }, [])

  return (
    <DiagnosticsResult
      title="Firebase Authentication"
      description="Connect to https://www.googleapis.com"
      status={status}
      error={error}
    />
  )
}
